import { get, isNil } from 'lodash'

// Buffer time before expiration to trigger refresh (2 minutes in milliseconds)
const REFRESH_BUFFER_MS = 2 * 60 * 1000

/**
 * Calculate the absolute expiration timestamp from token
 * @param {Object} token - The token object with expiresIn field
 * @returns {number} - Unix timestamp of expiration
 */
const calculateExpirationTime = (token) => {
  const expiresIn = get(token, 'expiresIn', 900) // Default 15 min
  return Date.now() + (expiresIn * 1000)
}

/**
 * Check if access token is expired or will expire within the buffer period
 * @param {number} expirationTime - Unix timestamp of expiration
 * @returns {boolean}
 */
const isTokenExpiringSoon = (expirationTime) => {
  if (isNil(expirationTime)) {
    return true
  }
  return Date.now() >= (expirationTime - REFRESH_BUFFER_MS)
}

/**
 * Check if token is completely expired (no buffer)
 * @param {number} expirationTime - Unix timestamp of expiration
 * @returns {boolean}
 */
const isTokenExpired = (expirationTime) => {
  if (isNil(expirationTime)) {
    return true
  }
  return Date.now() >= expirationTime
}

/**
 * Get time in milliseconds until token should be refreshed (accounting for buffer)
 * @param {number} expirationTime - Unix timestamp of expiration
 * @returns {number} - Milliseconds until refresh should occur
 */
const getTimeUntilRefresh = (expirationTime) => {
  if (isNil(expirationTime)) {
    return 0
  }
  const timeUntilRefresh = expirationTime - REFRESH_BUFFER_MS - Date.now()
  return Math.max(0, timeUntilRefresh)
}

export {
  calculateExpirationTime,
  isTokenExpiringSoon,
  isTokenExpired,
  getTimeUntilRefresh,
  REFRESH_BUFFER_MS,
}
